import { Box, Grid, Paper, Typography } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import AttachmentForm from "../../../../forms/medicoAssistente/AttachmentForm";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../../../../forms/FormFieldAttachmentBase";

interface IMedicoAssistenteDataComponentProps {
  MedicoAssistenteAttachmentForm: AttachmentForm;
  onInputChange: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
  onDeleteFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
}

export default function MedicoAssistenteAttachmentDataComponent(
  props: IMedicoAssistenteDataComponentProps
) {
  return (
    <div>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Atestado de Capacidade Física e Cognitiva *"
                name="AtestadoCapacidadeFisicaCognitiva"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carta de apresentação do médico do Corpo Clínico titular da equipe *"
                name="CartaApresentacaoMedico"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CartaApresentacaoMedico
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm.CartaApresentacaoMedico
                    .Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm.CartaApresentacaoMedico
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CartaApresentacaoMedico",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CartaApresentacaoMedico
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CartaApresentacaoMedico",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CartaApresentacaoMedico
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carteira de Vacinação atualizada"
                infoMessage="Em caso de recusa, favor preencher o Termo disponível na última página da solicitação"
                name="CarteiraVacinacaoOuTermo"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CarteiraVacinacaoOuTermo
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm.CarteiraVacinacaoOuTermo
                    .Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm.CarteiraVacinacaoOuTermo
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CarteiraVacinacaoOuTermo",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CarteiraVacinacaoOuTermo
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CarteiraVacinacaoOuTermo",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CarteiraVacinacaoOuTermo
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Ética Profissional (emitida pelo site do CREMESP)*"
                name="CertidaoEticaProfissional"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CertidaoEticaProfissional
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm.CertidaoEticaProfissional
                    .Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm.CertidaoEticaProfissional
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoEticaProfissional",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CertidaoEticaProfissional
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoEticaProfissional",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CertidaoEticaProfissional
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Quitação *"
                name="CertidaoQuitacao"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CertidaoQuitacao
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm.CertidaoQuitacao.Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm.CertidaoQuitacao.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoQuitacao",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CertidaoQuitacao
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoQuitacao",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CertidaoQuitacao
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia da Carteira do Conselho *"
                name="CopiaCRM"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CopiaCRM.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoAssistenteAttachmentForm.CopiaCRM.Values}
                error={props.MedicoAssistenteAttachmentForm.CopiaCRM.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaCRM",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CopiaCRM
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaCRM",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CopiaCRM
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do RG *"
                name="CopiaRG"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.CopiaRG.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoAssistenteAttachmentForm.CopiaRG.Values}
                error={props.MedicoAssistenteAttachmentForm.CopiaRG.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaRG",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CopiaRG
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaRG",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.CopiaRG
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Currículo resumido atualizado *"
                name="CurriculoResumidoAtualizado"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm
                    .CurriculoResumidoAtualizado.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm
                    .CurriculoResumidoAtualizado.Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm
                    .CurriculoResumidoAtualizado.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CurriculoResumidoAtualizado",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CurriculoResumidoAtualizado
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CurriculoResumidoAtualizado",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CurriculoResumidoAtualizado
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Uma foto 3x4 fundo branco *"
                name="Foto"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.Foto.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoAssistenteAttachmentForm.Foto.Values}
                error={props.MedicoAssistenteAttachmentForm.Foto.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "Foto",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.Foto
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "Foto",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.Foto
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Declaração de Conflitos - Anexo *"
                name="DeclaracaoConflitos"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm.DeclaracaoConflitos
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm.DeclaracaoConflitos
                    .Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm.DeclaracaoConflitos.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "DeclaracaoConflitos",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.DeclaracaoConflitos
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "DeclaracaoConflitos",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.DeclaracaoConflitos
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do Diploma de Graduação em Medicina *"
                name="CopiaDiplomaGraduacaoMedicina"
                limitedFiles={
                  props.MedicoAssistenteAttachmentForm
                    .CopiaDiplomaGraduacaoMedicina.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoAssistenteAttachmentForm
                    .CopiaDiplomaGraduacaoMedicina.Values
                }
                error={
                  props.MedicoAssistenteAttachmentForm
                    .CopiaDiplomaGraduacaoMedicina.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Comprovante de Vacinação COVID19"
                name="ComprovanteVacinaCovid"
                limitedFiles={props.MedicoAssistenteAttachmentForm.ComprovanteVacinaCovid.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.MedicoAssistenteAttachmentForm.ComprovanteVacinaCovid.Values}
                error={props.MedicoAssistenteAttachmentForm.ComprovanteVacinaCovid.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "ComprovanteVacinaCovid",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "ComprovanteVacinaCovid",
                    props.MedicoAssistenteAttachmentForm,
                    fieldAttachment,
                    props.MedicoAssistenteAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
              />
            </Grid>

          </Grid>
        </Grid>
      </Grid>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia do Título de Especialista ou Residência Médica *
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Título de Especialista"
                    name="CopiaTituloEspecialista"
                    limitedFiles={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaTituloEspecialista.LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaTituloEspecialista.Values
                    }
                    error={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaTituloEspecialista.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaTituloEspecialista",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaTituloEspecialista
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaTituloEspecialista",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaTituloEspecialista
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Residência Médica"
                    name="CopiaResidenciaMedica"
                    limitedFiles={
                      props.MedicoAssistenteAttachmentForm.CopiaResidenciaMedica
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoAssistenteAttachmentForm.CopiaResidenciaMedica
                        .Values
                    }
                    error={
                      props.MedicoAssistenteAttachmentForm.CopiaResidenciaMedica
                        .Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaResidenciaMedica",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaResidenciaMedica
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaResidenciaMedica",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaResidenciaMedica
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia dos certificados do curso de reanimação
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento ACLS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoACLS"
                    limitedFiles={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Values
                    }
                    error={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento PALS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoPALS"
                    limitedFiles={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Values
                    }
                    error={
                      props.MedicoAssistenteAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.MedicoAssistenteAttachmentForm,
                        fieldAttachment,
                        props.MedicoAssistenteAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
}
